import React, { useState, useEffect, useRef } from "react";
import Title from "../Title/Title";
import Button from "../Button/Button";
import Paragraph from "../Paragraph/Paragraph";
import styles from "./Result.module.scss";
import classNames from "classnames";
import { SITE_URL } from "../../state/consts";
import { IconButton, Snackbar } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { FacebookShareButton, WhatsappShareButton } from "react-share";

import { FacebookIcon, WhatsappIcon } from "react-share";

function Result({
  score,
  title,
  text,
  imageSrc,
  posterContainer,
  optionsContainer,
  handlerBack,
}) {
  const [offset, setOffset] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const [showConditions, setShowConditions] = useState(false);
  const textAreaRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ImageURL = SITE_URL + imageSrc;

  // кнопка скопировать
  const [open, setOpen] = useState(false);

  const testClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(window.location.toString());
  };

  function copyToClipboard(e) {
    textAreaRef.current.select();
    console.log(textAreaRef.current.value);
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess(
      <div className={styles.copySuccess}>O link foi copiado</div>,
    );

    setTimeout(() => {
      setCopySuccess(
        <div className={classNames(styles.copySuccess, styles.displayNone)}>
          O link foi copiado
        </div>,
      );
    }, "1500");
  }

  return (
    <>
      {!showConditions ? (
        <>
          <div className={posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={classNames(optionsContainer, styles.before)}>
            <div
              className={classNames({
                [styles.resultPosterContainer]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div className={styles.contentWrapper}>
                <div className={styles.score}>{score}</div>
                <Title value={title} />
                {text}
              </div>

              <div className={styles.promoBox}>
                <div className={styles.promoButtonsWrapper}>
                  <div className={styles.promoWrapper}>
                    <div className={styles.inputPromoWrapper}>
                      <form className={styles.form}>
                        <input
                          ref={textAreaRef}
                          value="SEJARAH"
                          className={styles.inputPromo}
                          readOnly
                        />
                      </form>

                      <button onClick={copyToClipboard} className={styles.copy}>
                        <ContentCopyIcon />
                      </button>
                    </div>
                  </div>

                  <div className={styles.buttonBox}>
                    <a
                      href="https://taximaxim.onelink.me/KKXl?pid=ID_Quiz&deep_link_value=maximzakaz%3A%2F%2F&deep_link_sub1=app%3Faction%3Dpromo%26code%3DSEJARAH&af_dp=maximzakaz%3A%2F%2Fapp%3Faction%3Dpromo%26code%3DSEJARAH&af_web_dp=https%3A%2F%2Ftaximaxim.com%2Fapp&c=PM4181190126"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button
                        value="Terapkan kode promo"
                        className={styles.buttonPresent}
                      />
                    </a>

                    <Button
                      value="Ikuti kuis sekali lagi"
                      className={styles.buttonPresent}
                      onClick={handlerBack}
                      id="refresh"
                    />

                    <div
                      className={styles.buttonBoxLink}
                      onClick={() => {
                        setShowConditions(true);
                      }}
                    >
                      Ketentuan promosi
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={classNames(
                  styles.contentWrapper,
                  styles.socialWrapper,
                )}
              >
                <Paragraph value="Bagikan" />
                <div className={styles.social}>
                  <FacebookShareButton
                    url={SITE_URL}
                    title="Maxim menghadiahkan Rp200.000 untuk perjalanan cukup hanya dengan mengikuti kuis tentang sejarah negeri ini. Kuisnya menarik, ayo ikutan!"
                    image={ImageURL}
                    hashtag="#Maxim"
                    id="facebook"
                  >
                    <FacebookIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.facebook)}
                    />
                  </FacebookShareButton>

                  <WhatsappShareButton
                    url={SITE_URL}
                    title="Maxim menghadiahkan Rp200.000 untuk perjalanan cukup hanya dengan mengikuti kuis tentang sejarah negeri ini. Kuisnya menarik, ayo ikutan!"
                    image={ImageURL}
                    id="whatsapp"
                  >
                    <WhatsappIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.whatsapp)}
                    />
                  </WhatsappShareButton>

                  <div id="sharelink">
                    <IconButton
                      onClick={testClick}
                      color="primary"
                      className={styles.share}
                    >
                      <ShareIcon />
                    </IconButton>
                    <Snackbar
                      message="Tautan disalin"
                      anchorOrigin={{ vertical: "top", horizontal: "center" }}
                      autoHideDuration={1000}
                      onClose={() => setOpen(false)}
                      open={open}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {copySuccess}
        </>
      ) : (
        <>
          <div className={styles.posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={styles.resultContainer} m2>
            <div
              className={classNames({
                [styles.resultContainerBox]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div>
                <b>
                  <Paragraph value="Syarat dan Ketentuan Umum – Maxim Quiz: «Maxim untuk Anak»" />
                </b>
                <Paragraph value="Syarat dan ketentuan berikut ini («S&K» / «Syarat dan Ketentuan») berlaku untuk kontes kuis online bertema edukasi keselamatan lalu lintas («Kuis») yang diselenggarakan oleh  Maxim Indonesia («Penyelenggara»)." />
                <b>
                  <Paragraph value="Ketentuan Kuis:" />
                </b>
                <ul>
                  <li>
                    <Paragraph value="Kuis ini terbuka bagi seluruh individu yang merupakan Warga Negara Indonesia, telah mencapai usia 18 tahun pada saat berpartisipasi, dan bagi anak dengan usia di bawah 18 tahun dapat berpartisipasi dalam kuis dengan panduan serta bimbingan dari orang tua mereka." />
                  </li>
                  <li>
                    <Paragraph value="Kuis ini bertujuan untuk mengedukasi orang tua dan anak-anak mengenai sejarah Indonesia, termasuk peristiwa-peristiwa penting, tokoh nasional, serta nilai-nilai kebangsaan yang membentuk perjalanan bangsa Indonesia dari masa ke masa." />
                  </li>
                  <li>
                    <Paragraph value="Peserta wajib mengikuti instruksi yang tersedia di halaman Kuis Penyelenggara." />
                  </li>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Peserta yang memenuhi syarat adalah mereka yang:" />
                  </li>
                  <ul>
                    <li>
                      <Paragraph value="Mengisi informasi yang diminta (nama lengkap, alamat email aktif, nomor telepon)." />
                    </li>
                    <li>
                      <Paragraph value="Menjawab pertanyaan kuis secara benar dan sebanyak mungkin." />
                    </li>
                    <li>
                      <Paragraph value="Mematuhi seluruh ketentuan yang tercantum dalam dokumen S&K ini." />
                    </li>
                  </ul>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Pemenang akan menerima kode promosi SEJARAH yang dapat digunakan untuk mendapatkan diskon 10% dari total pembelian (maksimal Rp200.000)" />
                  </li>
                  <li>
                    <Paragraph value="Hadiah tidak dapat ditukar dengan uang tunai, tidak dapat dipindahtangankan, dan hanya berlaku untuk pemenang yang sah." />
                  </li>
                  <li>
                    <Paragraph value="Hadiah tidak dapat ditukar dengan uang tunai, tidak dapat dipindahtangankan, dan hanya berlaku untuk pemenang yang sah." />
                  </li>
                  <li>
                    <Paragraph value="Penyelenggara berhak mengganti hadiah dengan nilai yang setara apabila dianggap perlu." />
                  </li>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Penyelenggara berhak membatalkan partisipasi yang dicurigai:" />
                  </li>
                  <ul>
                    <li>
                      <Paragraph value="Menggunakan data yang tidak benar atau menyesatkan." />
                    </li>
                    <li>
                      <Paragraph value="Menggunakan identitas ganda atau akun palsu." />
                    </li>
                    <li>
                      <Paragraph value="Melanggar ketentuan hukum dan etika lalu lintas yang diangkat dalam Kuis ini." />
                    </li>
                  </ul>
                </ul>
                <ul>
                  <li>
                    <Paragraph value="Penyelenggara tidak akan memberikan klarifikasi atas jawaban yang telah digunakan dalam Kuis." />
                  </li>
                  <li>
                    <Paragraph value="Identitas Peserta yang Memenuhi Syarat ditentukan sepenuhnya oleh Penyelenggara." />
                  </li>
                  <li>
                    <Paragraph value="Seluruh kewajiban pajak hadiah ditanggung oleh pemenang." />
                  </li>
                  <li>
                    <Paragraph value="Penyelenggara berhak memverifikasi identitas dan keabsahan peserta kapan pun selama atau setelah Kuis berlangsung." />
                  </li>
                  <li>
                    <Paragraph value="Penjurian dilakukan oleh Tim Penyelenggara berdasarkan jumlah jawaban benar terbanyak dan waktu pengiriman." />
                  </li>
                </ul>

                <Button
                  className={styles.buttonConditions}
                  value="Kembali"
                  onClick={() => {
                    setShowConditions(false);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Result;
